import { render, staticRenderFns } from "./FloatingMenu.vue?vue&type=template&id=766a5e28&scoped=true"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"
import style0 from "./FloatingMenu.vue?vue&type=style&index=0&id=766a5e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a5e28",
  null
  
)

export default component.exports